import React from "react";
import { Box, Typography, Grid, Card, CardMedia, CardContent } from "@mui/material";

const products = [
  {
    name: "Coconut oil",
    volume: "1L & 2L",
    image: "https://i.postimg.cc/j50KcYC6/Screenshot-2025-01-29-125301-removebg-preview.png",
  },
  {
    name: "Tomato paste",
    volume: "800g",
    image: "https://i.postimg.cc/fLT5fCm1/d1f6339cfb33ecee24ff2c13722e3688.png",
  },
  {
    name: "Sunflower Oil",
    volume: "5 L",
    image: "https://i.postimg.cc/qvx5czWh/190e6adb5eaada7bf862984380649611.png",
  },
  {
    name: "Pickles (Mango / Lime / Mixed Vegitables)",
    volume: "5KG",
    image: "https://i.postimg.cc/tCqkrZs1/Screenshot-2025-01-28-095805-removebg-preview.png",
  },
  {
    name: "Jaggery cubes",
    volume: "1 Kg",
    image: "https://i.postimg.cc/VvwtFLxv/f07e236e4aff94639ecd8e281783e089.png",
  },
  {
    name: "Sunflower Oil",
    volume: "1.5 L",
    image: "https://i.postimg.cc/fLfnJ8ZF/12e095e25ff2489c8c2b973665bd8bd2.png",
  },
  {
    name: "Table salt",
    volume: "1 Kg",
    image: "https://i.postimg.cc/7YPLvT5g/7f7fc98628c183f277d0ece5275dba68-1.png",
  },
  {
    name: "Garcinia cambodge",
    volume: "100g",
    image: "https://i.postimg.cc/90rNTpxd/caca12c44f52a03916253ca13ee11d76.png",
  },
  {
    name: "Basmati rice",
    volume: "35 Kg",
    image: "https://i.postimg.cc/T1LChPwQ/cb8ec68e033660a71c9c1b43d6d56f1f.png",
  },
  {
    name: "Rice powder",
    volume: "15 Kg",
    image: "https://i.postimg.cc/k5T0bBJd/d61d22d62763ef455203b6e2584f88da.png",
  },
  {
    name: "Cocunut Oil",
    volume: "1 L",
    image: "https://i.postimg.cc/2y0rj21n/35783c5cb59a4b77399d1284894f2c44.png",
  },
  {
    name: "Washing Powder",
    volume: "15 Kg",
    image: "https://i.postimg.cc/HsPdfvDg/85644ab5f5836456e08920d099bbc922.png",
  },
  {
    name: "Tamarind",
    volume: "150g, 500g & 1Kg",
    image: "https://i.postimg.cc/nzktT0YN/46794443daebf6d23c3268f1df24ca3e.png",
  },
  {
    name: "Rock salt",
    volume: "1 Kg",
    image: "https://i.postimg.cc/NGdcHC0H/bdb6d0930cf75c70147bc3a5a14f93e3.png",
  },
  {
    name: "Olive Oil",
    volume: "4 L",
    image: "https://i.postimg.cc/FFTYHZ5P/fe5656cff34a9d3a2ed1c49b3aa2da2e.png",
  },
  {
    name: "Jeerakasala Rice",
    volume: "18Kg",
    image: "https://i.postimg.cc/fTQyZmcL/Screenshot-2025-01-28-100204-removebg-preview.png",
  },
  {
    name: "Basmati Rice Premium",
    volume: "39 Kg",
    image: "https://i.postimg.cc/J0rcRYnq/Screenshot-2025-01-27-152710-removebg-preview.png",
  },
  {
    name: "Cashew Nut Broken",
    volume: "10 Kg",
    image: "https://i.postimg.cc/wjQNjcC4/Screenshot-2025-01-27-152817-removebg-preview.png",
  },
  {
    name: "Desiccated Cocunut Powder",
    volume: "24Kg & 7Kg",
    image: "https://i.postimg.cc/RZd3BCtj/Screenshot-2025-01-27-152913-removebg-preview.png",
  },
  {
    name: "Hot Sauce",
    volume: "88 ML",
    image: "https://i.postimg.cc/VvX6Hz1Z/Screenshot-2025-01-27-153056-removebg-preview.png",
  },
  {
    name: "Handwash Liquid",
    volume: "5L",
    image: "https://i.postimg.cc/fRRzYc3r/Screenshot-2025-01-27-153137-removebg-preview.png",
  },
  {
    name: "Dishwash Liquid",
    volume: "5L",
    image: "https://i.postimg.cc/j2M9T7sD/Screenshot-2025-01-27-153243-removebg-preview.png",
  },

];

const ProductGrid = () => {
  return (
    <Box sx={{ padding: "2rem", backgroundColor: "#fff" }}>
      {/* Heading */}
      <Typography
        variant="h4"
        sx={{
          fontWeight: "bold",
          color: "green",
          textAlign: "center",
          marginBottom: "2rem",
          fontFamily: '"Montserrat", sans-serif',
        }}
      >
        Our Products
      </Typography>

      {/* Product Grid */}
      <Grid container spacing={3}>
        {products.map((product, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Card
              sx={{
                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                borderRadius: "12px",
                textAlign: "center",
                overflow: "hidden",
              }}
            >
              {/* Product Image */}
              <CardMedia
                component="img"
                image={product.image}
                alt={product.name}
                sx={{
                  height: "200px",
                  objectFit: "contain",
                  backgroundColor: "#E3EBD4",
                }}
              />
              {/* Product Details */}
              <CardContent sx={{ padding: "1rem", backgroundColor: "#98AF41" }}>
                <Typography
                  variant="h6"
                  sx={{ fontWeight: "bold", color: "white" }}
                >
                  {product.name}
                </Typography>
                <Typography variant="body2" sx={{ color: "white" }}>
                  ({product.volume})
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default ProductGrid;
